var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('list',{attrs:{"title":"Imóveis","tag":"properties","subtitle":"Nesta tela você cria e verifica os templates de consultas de veículos.","create-route":{ name: 'Template-Property-Create' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }